import { ClientFormConditionEvaluator, ContextWithEvalConditionEvaluator, FlowConditionEvaluator } from './ConditionEvaluator';

class ConditionEvaluatorFactory {
    static createEvaluator(type) {
        switch (type) {
            case 'clientForm':
                return ClientFormConditionEvaluator.current();
            case 'flow':
                return FlowConditionEvaluator.current();
            case 'context':
                return ContextWithEvalConditionEvaluator.current();
            default:
                throw new Error(`Unknown evaluator type: ${type}`);
        }
    }
}

export default ConditionEvaluatorFactory;
